const TET_CODES = ['TET', 'TET_INNER', 'TET_PROVINCE', 'TET_PROVINCE_PACKAGE'];

// requireDate: only Tết ÂL and rows below require a date range when a price is filled.
export const RENTAL_OFFER_ROWS = [
  {code: 'INNER_RETURN', label: 'Thuê nội thành nhận - kia trả', requireDate: false, noDate: true, alwaysShow: true},
  {code: 'INNER_24H', label: 'Thuê nội thành 24h', requireDate: false, noDate: true},
  {code: 'FS_INNER_SAME_DAY', label: 'Flash Sale nội thành trong ngày', requireDate: false},
  {code: 'FS_INNER_24H', label: 'Flash Sale nội thành 24h', requireDate: false},
  {code: 'FS_PROVINCE_24H', label: 'Flash Sale Tỉnh 24h', requireDate: false},
  {code: 'FS_INNER_PICKUP_RETURN', label: 'Flash Sale nội thành nay nhận - kia trả', requireDate: false},
  {code: 'FS_PICKUP_RETURN', label: 'Flash Sale nay nhận - kia trả', requireDate: false},
  {code: 'FS_INNER_RETURN', label: 'Flash Sale nội thành nhận - kia trả', requireDate: false},
  {code: 'FS_PROVINCE_PICKUP_RETURN', label: 'Flash Sale Tỉnh nay nhận - kia trả', requireDate: false},
  {
    code: 'FS_FULLSET_RETURN',
    label: 'Flash Sale Full set nay nhận - kia trả',
    requireDate: false,
    fullSet: true,
  },
  {
    code: 'FS_FULLSET_INNER_RETURN',
    label: 'Flash Sale Full set nội thành nhận - kia trả',
    requireDate: false,
    fullSet: true,
  },
  {
    code: 'FS_FULLSET_PROVINCE_PICKUP_RETURN',
    label: 'Flash Sale Full set Tỉnh nay nhận - kia trả',
    requireDate: false,
    fullSet: true,
  },
  {code: 'FS_FULLSET_INNER_24H', label: 'Flash Sale Full set nội thành 24h', requireDate: false, fullSet: true},
  {code: 'FS_FULLSET_PROVINCE_24H', label: 'Flash Sale Full set Tỉnh 24h', requireDate: false, fullSet: true},
  {
    code: 'FS_FULLSET_INNER_SAME_DAY',
    label: 'Flash Sale Full set nội thành trong ngày',
    requireDate: false,
    fullSet: true,
  },
  {code: 'TET_INNER', label: 'Tết ÂL nội thành', requireDate: true, tet: 'tetInner'},
  {code: 'TET_PROVINCE', label: 'Tết ÂL Tỉnh', requireDate: true, tet: 'tetProvince'},
  {code: 'TET_PROVINCE_PACKAGE', label: 'Tết ÂL Tỉnh có Gói', requireDate: true, tet: 'tetProvince'},
  {code: 'PROVINCE_24H', label: 'Tỉnh 24h', requireDate: true},
  {code: 'PROVINCE_PACKAGE_24H', label: 'Tỉnh có Gói 24h', requireDate: true},
];

const LABEL = RENTAL_OFFER_ROWS.reduce(
  (acc, row) => {
    acc[row.code] = row.label;
    return acc;
  },
  {INNER_SAME_DAY: 'Thuê nội thành trong ngày', PROVINCE_RENT: 'Thuê tỉnh nhận - kia trả', TET: 'Tết ÂL'}
);

const day = value => {
  if (!value) return null;
  if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  const text = typeof value === 'string' ? value.slice(0, 10) : '';
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
  if (!match) {
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return null;
    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  }
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export const parseOffers = raw => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const inWindow = (today, start, end) => {
  const current = day(today);
  const from = day(start);
  const to = day(end);
  if (!current) return true;
  if (!from && !to) return true;
  if (from && current < from) return false;
  if (to && current > to) return false;
  return true;
};

export const isPriceVisible = (enabled, start, end, today = new Date()) => {
  if (!enabled) return false;
  return inWindow(today, start, end);
};

const overlaps = (from, to, start, end) => {
  if (!from || !to) return false;
  if (!start && !end) return true;
  const winStart = start || new Date(0);
  const winEnd = end || new Date(8640000000000000);
  return from <= winEnd && to >= winStart;
};

const calendarDays = (from, to) => Math.round((to - from) / 86400000) + 1;

const overflowDays = (from, to, start, end) => {
  const winStart = start || new Date(0);
  const winEnd = end || new Date(8640000000000000);
  let count = 0;
  for (
    let cursor = new Date(from);
    cursor <= to;
    cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1)
  ) {
    if (cursor < winStart || cursor > winEnd) count += 1;
  }
  return count;
};

const offersOf = item => parseOffers(item?.rentalOffers);

const pick = offers =>
  [...offers].sort((a, b) => {
    const flash = (b.code || '').startsWith('FS_') - (a.code || '').startsWith('FS_');
    if (flash) return flash;
    return (a.price || 0) - (b.price || 0);
  })[0];

const applies = (offer, from, to, fullSetIndex) => {
  if (!offer?.enabled || !(offer.price > 0)) return false;
  if (offer.fullSetIndex > 0 && offer.fullSetIndex !== fullSetIndex) return false;
  if ((offer.code || '').includes('FULLSET') && !(fullSetIndex > 0)) return false;
  return overlaps(from, to, day(offer.startDate), day(offer.endDate));
};

// Returns {total, reason} when a Tet, 24h, same-day or pickup-return price applies. Null keeps the old formula.
export const chargeRental = item => {
  const from = day(item?.dateFrom);
  const to = day(item?.dateTo);
  const quantities = Number(item?.quantities) || 0;
  if (!from || !to || !quantities) return null;
  const fullSetIndex = Number(item?.fullSetIndex) || 0;
  const offers = offersOf(item);
  const tet = pick(offers.filter(offer => TET_CODES.includes(offer.code) && applies(offer, from, to, fullSetIndex)));
  if (tet) {
    const extra = overflowDays(from, to, day(tet.startDate), day(tet.endDate));
    return {total: Math.round(tet.price * quantities * (1 + 0.1 * extra)), reason: 'tet'};
  }
  const days = calendarDays(from, to);
  if (days === 2) {
    const offer = pick(offers.filter(row => (row.code || '').endsWith('_24H') && applies(row, from, to, fullSetIndex)));
    if (offer) return {total: Math.round(offer.price * quantities), reason: '24h'};
  }
  if (days === 1) {
    const offer = pick(
      offers.filter(
        row =>
          (row.code === 'INNER_SAME_DAY' || (row.code || '').endsWith('_SAME_DAY')) &&
          applies(row, from, to, fullSetIndex)
      )
    );
    if (offer) return {total: Math.round(offer.price * quantities), reason: 'sameDay'};
  }
  const pickupReturn = pick(
    offers.filter(row => (row.code || '').endsWith('_RETURN') && applies(row, from, to, fullSetIndex))
  );
  if (pickupReturn) {
    const extra = Math.max(days - 3, 0);
    return {total: Math.round(pickupReturn.price * quantities * (1 + 0.1 * extra)), reason: 'return'};
  }
  return null;
};

const shippingNote = offer => {
  if (!(offer?.code || '').startsWith('FS_') || !(offer.code || '').endsWith('_24H')) return '';
  if (!offer.description) return 'Không ship nhà xe/hỏa tốc';
  return 'Chỉ nhận nhà xe/hỏa tốc 2 chiều';
};

// Prices still in their window. Consumer web shows rows ticked «Hiển thị bên ngoài»;
// staff ERP (`staff: true`) shows rows ticked in the checkbox next to the name.
export const offerLines = (product, {staff = false, today = new Date()} = {}) => {
  const visible = offersOf(product).filter(
    offer =>
      offer.price > 0 && (staff ? offer.enabled : offer.showOutside) && inWindow(today, offer.startDate, offer.endDate)
  );
  const used = new Set();
  const lines = [];
  const pair = (left, right) => {
    const a = visible.find(offer => offer.code === left);
    const b = visible.find(offer => offer.code === right);
    if (!a || !b) return;
    used.add(left);
    used.add(right);
    lines.push({
      key: `${left}+${right}`,
      label: 'Flash Sale 24h',
      price: a.price,
      desc: a.description || b.description,
      shipping: shippingNote(a.description ? a : b),
    });
  };
  pair('FS_INNER_24H', 'FS_PROVINCE_24H');
  pair('FS_FULLSET_INNER_24H', 'FS_FULLSET_PROVINCE_24H');
  visible.forEach(offer => {
    if (used.has(offer.code)) return;
    lines.push({
      key: offer.code,
      label: LABEL[offer.code] || offer.code,
      price: offer.price,
      desc: offer.description,
      shipping: shippingNote(offer),
    });
  });
  return lines;
};

// Same rows the API adds to cart items; only product objects carry these fields.
const legacyRows = item => {
  const row = (code, prefix, startDate = '', endDate = '') => {
    const enabled = !!item?.[`is${prefix}Enabled`];
    const showOutside = !!item?.[`is${prefix}EnabledOutside`];
    const price = item?.[`${prefix.charAt(0).toLowerCase()}${prefix.slice(1)}Price`];
    if (!(price > 0) || (!enabled && !showOutside)) return [];
    const description = item[`${prefix.charAt(0).toLowerCase()}${prefix.slice(1)}Desc`] || '';
    return [{code, enabled, showOutside, price, description, startDate, endDate}];
  };
  const tetDates = item?.holidayRentStartDate && item?.holidayRentEndDate;
  return [
    ...row('INNER_SAME_DAY', 'Rent1Day'),
    ...row('PROVINCE_RENT', 'ProvinceRent'),
    ...(tetDates ? row('TET', 'HolidayRent', item.holidayRentStartDate, item.holidayRentEndDate) : []),
  ];
};

// Lines for cart items and product rows: new offers plus the old columns still on the form.
export const cartOfferLines = (item, options) => {
  const offers = offersOf(item);
  const extra = legacyRows(item).filter(row => !offers.some(offer => offer.code === row.code));
  return offerLines({rentalOffers: [...offers, ...extra]}, options);
};

export const serializeRentalOffers = map => {
  const offers = RENTAL_OFFER_ROWS.map(row => {
    const value = map?.[row.code] || {};
    const range = value.dateRange;
    return {
      code: row.code,
      enabled: !!value.enabled,
      price: Number(value.price) || 0,
      description: value.description || '',
      showOutside: row.alwaysShow ? !!value.enabled : !!value.showOutside,
      startDate: range?.[0]?.format ? range[0].format('YYYY-MM-DD') : '',
      endDate: range?.[1]?.format ? range[1].format('YYYY-MM-DD') : '',
      fullSetIndex: Number(value.fullSetIndex) || 0,
    };
  }).filter(offer => offer.enabled || offer.price > 0 || offer.startDate || offer.endDate);
  return JSON.stringify(offers);
};

export const rentalOfferFormValues = (raw, moment) => {
  const map = {};
  parseOffers(raw).forEach(offer => {
    map[offer.code] = {
      enabled: !!offer.enabled,
      price: offer.price || undefined,
      description: offer.description,
      showOutside: !!offer.showOutside,
      fullSetIndex: offer.fullSetIndex || undefined,
      dateRange: offer.startDate && moment ? [moment(offer.startDate), moment(offer.endDate)] : undefined,
    };
  });
  return map;
};
